import { useNavigate } from 'react-router-dom';
import { Disc3, Play } from 'lucide-react';
import { PATNA_IMAGES } from '../lib/patna';
import { usePlayer } from '../context/PlayerContext';

const Onboarding = () => {
  const navigate = useNavigate();
  const { playRandom } = usePlayer();
  const enter = () => {
    try { localStorage.setItem('pkp_onboarded', '1'); } catch (e) {}
    // Signal that a song is being kicked off from here so AutoPlayHook doesn't
    // race and fetch a second random song. Cleared once the auto flow completes.
    try { sessionStorage.setItem('pkp_autoplay_lock', '1'); } catch (e) {}
    // This tap counts as the user gesture that unlocks browser audio —
    // kick off a random song immediately so music is already flowing
    // by the time they land on Home.
    playRandom({ expand: false })
      .catch(() => {})
      .finally(() => { try { sessionStorage.removeItem('pkp_autoplay_lock'); } catch (e) {} });
    navigate('/');
  };
  return (
    <div className="min-h-screen relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={PATNA_IMAGES.golghar}
          alt="Golghar, Patna"
          className="w-full h-full object-cover opacity-45"
          onError={(e) => { e.currentTarget.src = PATNA_IMAGES.gramophone; }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#120505]/50 via-[#120505]/85 to-[#120505]" />
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(1200px 400px at 80% 20%, rgba(255,0,127,0.15), transparent 60%)'
        }} />
      </div>
      <div className="relative z-10 max-w-md mx-auto px-6 pt-16 pb-10 flex flex-col min-h-screen">
        <div className="flex items-center gap-2 fade-in-up">
          <span className="w-11 h-11 rounded-full bg-gradient-to-br from-[#FFB800] to-[#FF007F] flex items-center justify-center shadow-[0_0_30px_rgba(255,0,127,0.5)]">
            <Disc3 className="w-6 h-6 text-[#120505] vinyl-spin" />
          </span>
          <div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#FFB800]">Est. 2026 · Patna</div>
          </div>
        </div>

        <div className="flex-1 flex flex-col justify-center gap-5">
          <div className="text-xs uppercase tracking-[0.35em] text-[#FF007F] fade-in-up" style={{ animationDelay: '0.05s' }}>
            Suniye aur Jhoomiye
          </div>
          <h1 className="font-display text-5xl sm:text-6xl leading-[0.9] text-[#FFF3E0] fade-in-up" style={{ animationDelay: '0.1s' }}>
            Patna Ke<br />
            <span className="text-[#FFB800]">Presleys</span>
          </h1>
          <div className="w-16 h-px bg-[#FF007F] fade-in-up" style={{ animationDelay: '0.2s' }} />
          <p className="text-lg text-[#FFF3E0]/90 font-body leading-relaxed fade-in-up" style={{ animationDelay: '0.3s' }}>
            <span className="italic text-[#FFB800]">Bihar ka beat, Bollywood ka jazba.</span><br />
            Ganga kinare se lekar Golghar tak — a curated collection of Hindi music, from the golden 80s to the millennium anthems.
          </p>
        </div>

        <div className="space-y-3 fade-in-up" style={{ animationDelay: '0.4s' }}>
          <button
            data-testid="onboarding-enter-btn"
            onClick={enter}
            className="w-full h-14 rounded-full bg-[#FFB800] text-[#120505] font-bold flex items-center justify-center gap-2 hover:scale-[1.02] active:scale-[0.98] transition-transform shadow-[0_8px_28px_rgba(255,184,0,0.35)]"
          >
            <Play className="w-5 h-5 fill-current" />
            <span>Enter the Studio</span>
          </button>
          <p className="text-xs text-center text-[#BFA5A5]">Install to home screen</p>
        </div>
      </div>
    </div>
  );
};

export default Onboarding;
